import { render, staticRenderFns } from "./trumbowyg.vue?vue&type=template&id=6e979cd0"
import script from "./trumbowyg.vue?vue&type=script&lang=js"
export * from "./trumbowyg.vue?vue&type=script&lang=js"
import style0 from "./trumbowyg.vue?vue&type=style&index=0&id=6e979cd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports